import { Component, OnInit, Input } from '@angular/core';
import { Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { ShellTrackHandlers } from '@cigna/chcp/shared/analytics-util';
import { DialogWhatIsTempIdComponent } from '../dialog-what-is-temp-id/dialog-what-is-temp-id.component';
import { DialogWamFaqComponent } from '../dialog-wam-faq/dialog-wam-faq.component';
import { DialogVideoEmbedComponent } from '@cigna/chcp/shared/ui';

@Component({
  selector: 'cigna-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
  // for future when login uses async call and bizrouter goes away
  // @Input() servererror = false;
  // @Input() submitting = false;

  loginForm: FormGroup;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  submitted = false;
  hasWam = true;
  @Input() params: Params;

  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private analytics: ShellTrackHandlers,
  ) {}

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });

    if (this.params.status === 'wamerror' || this.params.status === 'nowam') {
      this.loginForm.controls.username.markAsTouched();
      this.loginForm.controls.password.markAsTouched();
    }
  }

  openWhatIsTemporaryIdModal() {
    this.dialog.open(DialogWhatIsTempIdComponent, {
      autoFocus: false,
      width: '600px',
    });
  }

  openHowToRegisterModal() {
    this.dialog.open(DialogVideoEmbedComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        title: 'How to register for access',
        id: '3726e34428244df79ca2c834a6f62dee',
        player: 'limelight',
        width: 800,
        height: 475,
      },
    });
  }

  openWamFaqModal(hasWam: boolean) {
    this.dialog.open(DialogWamFaqComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        hasWam,
      },
    });
  }

  submit() {
    if (this.loginForm.valid) {
      // special case we are injecting analytics into component  because
      // 1. there is no effect and
      // 2. button click isnt only way to submit form (can also press enter)
      this.analytics.trackEventOther(
        {},
        'Login',
        'ac-Login002-US1012734-Login Logout',
      );

      this.username.setValue(this.username.value.toLowerCase());
      this.submitted = true;
      return true;
    }
    return false;
  }

  get username(): FormControl {
    return this.loginForm.get('username') as FormControl;
  }

  get password(): FormControl {
    return this.loginForm.get('password') as FormControl;
  }

  get status(): string {
    return this.params && this.params.status ? this.params.status : '';
  }
}
